import React, {SyntheticEvent, useState} from "react"
import {FieldEditableMode, FieldEditableProps} from "../../../../proto/render/editable";
import ToggleButton from "../../../../../gd-form/form-element/toggle-button/toggle-button";

// const debug = "FieldTimeReportIsBillable_Editable"
const debug = false

// Not registered yet !!!!
export default function FieldTimeReportIsBillable_Editable(props:FieldEditableProps) {

    const canEdit = props.field.canEdit(props.model)

    const [mode, setMode] = useState(FieldEditableMode.VIEW)

    const value = props.field.getViewValue(props.model)
    debug && console.log(debug, 'render', value, props.model)

    const onMouseEnter = () => {
        if (!canEdit) return false

        if (mode === FieldEditableMode.VIEW) {
            setMode(FieldEditableMode.HOVERED)
        }
    }

    const onMouseLeave = () => {
        if (FieldEditableMode.HOVERED) setMode(FieldEditableMode.VIEW)
    }

    const onClick = (e: SyntheticEvent)=> {
        e.stopPropagation()
        // Not implemented
    }

    const toggleValue = (e: React.MouseEvent) => {
        debug && console.log(debug, 'toggleValue', canEdit)

        if (!canEdit) return

        onChange(!value)
    }

    const onChange = (value:any) => {
        debug && console.log(debug, 'onChange', value)

        if (props.disabled || !canEdit) return false

        props.onChange && props.onChange(value)
    }

    const classes = Classes("ui5-field-editable w-100-percent h-100-percent", "size-small", props.className, {
        'is-hovered': mode === FieldEditableMode.HOVERED
    })

    return (
        <div className      = {classes}
             onMouseEnter   = {onMouseEnter}
             onMouseLeave   = {onMouseLeave}
             onClick        = {onClick}>

            <ToggleButton
                icon            = "i5-no-cash"
                selectedIcon    = "i5-cash"
                value           = {value}
                onClick         = {toggleValue}
            />
        </div>
    )
}
